if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.setupMobileFlyAtc();
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        if (!this.validateRequiredPersonalizationFields()) return;

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
        this.syncMobileFlyAtcButton();
      }

      validateRequiredPersonalizationFields() {
        const productInfo = this.closest('product-info');
        if (!productInfo) return true;

        const candidates = Array.from(
          productInfo.querySelectorAll(
            '[required], [aria-required="true"], [data-required="true"], custom-fields .ma-custom-field-group input, custom-fields .ma-custom-field-group textarea, custom-fields .ma-custom-field-group select'
          )
        ).filter((field) => this.isValidatablePersonalizationField(field));

        const missingField = candidates.find((field) => !this.isPersonalizationFieldComplete(field, candidates));
        if (!missingField) return true;

        this.handleErrorMessage('Please complete all required personalization fields before adding this item to cart.');
        missingField.reportValidity?.();
        missingField.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(() => missingField.focus?.({ preventScroll: true }), 250);
        return false;
      }

      isValidatablePersonalizationField(field) {
        if (field.disabled || field.type === 'hidden') return false;
        if (field.closest('product-form') && !this.contains(field)) return false;
        return field.offsetParent !== null || field.getClientRects().length > 0;
      }

      isPersonalizationFieldComplete(field, fields) {
        if (field.type === 'radio' || field.type === 'checkbox') {
          const group = fields.filter((candidate) => candidate.name && candidate.name === field.name);
          return group.some((candidate) => candidate.checked);
        }
        if (field.type === 'file') return field.files.length > 0;
        return field.value.trim() !== '';
      }

      setupMobileFlyAtc() {
        const productInfo = this.closest('product-info');
        this.mobileFlyAtc = productInfo?.querySelector('[data-mobile-fly-atc]');
        if (!this.mobileFlyAtc) return;

        this.mobileFlyAtcButton = this.mobileFlyAtc.querySelector('button');
        this.mobileFlyAtcButton?.addEventListener('click', () => this.submitButton.click());
        this.mobileFlyAtc.hidden = false;
        this.mobileFlyAtcMedia = window.matchMedia('(max-width: 749px)');
        this.mobileFlyAtcOriginalButtonVisible = true;
        this.mobileFlyAtcMedia.addEventListener?.('change', () => this.updateMobileFlyAtcVisibility());
        this.syncMobileFlyAtcButton();

        new MutationObserver(() => this.syncMobileFlyAtcButton()).observe(this.submitButton, {
          attributes: true,
          childList: true,
          subtree: true,
        });

        if (!('IntersectionObserver' in window)) return;
        new IntersectionObserver(([entry]) => {
          this.mobileFlyAtcOriginalButtonVisible = entry.isIntersecting;
          this.updateMobileFlyAtcVisibility();
        }).observe(this.submitButton);
      }

      updateMobileFlyAtcVisibility() {
        if (!this.mobileFlyAtc) return;
        this.mobileFlyAtc.classList.toggle(
          'is-visible',
          this.mobileFlyAtcMedia.matches && !this.mobileFlyAtcOriginalButtonVisible
        );
      }

      syncMobileFlyAtcButton() {
        if (!this.mobileFlyAtcButton) return;
        const buttonText = this.mobileFlyAtcButton.querySelector('span');
        if (buttonText) buttonText.textContent = this.submitButtonText.textContent;
        this.mobileFlyAtcButton.disabled = this.submitButton.disabled || this.submitButton.getAttribute('aria-disabled') === 'true';
        this.mobileFlyAtcButton.classList.toggle('loading', this.submitButton.classList.contains('loading'));
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
